// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fx-6";
export var emphasizeQuantity = "_fx-3";
export var flatBottomCorners = "_fx-5";
export var productImage = "_fx-0";
export var quantityContainer = "_fx-2";
export var tooltip = "_fx-1";
export var wrapAndEllipsesOverflow = "_fx-4";